





























import Vue from "vue";
import vClickOutside from "v-click-outside";

export default Vue.extend({
  name: "BaseModalWindow",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data: function () {
    return {
      loaded: false,
    };
  },
  props: {
    showCloseIcon: Boolean,
    needCloseClickOutside: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    keymap: function () {
      return {
        esc: this.exit,
      };
    },
  },
  mounted() {
    this.loaded = true;
  },
  methods: {
    exit() {
      this.$emit("close");
    },
    onClickOutside(event) {
      //console.log("Clicked outside. Event: ", event);
      if (this.needCloseClickOutside) {
        this.loaded = false;
        setTimeout(() => {
          this.$emit("clickOutside");
        }, 200);
      }
    },
    onDblClick(event: MouseEvent) {},
    close() {
      this.loaded = false;
      setTimeout(() => {
        this.$emit("close");
      }, 200);
    },
  },
});
